<script xmlns:v-popover="http://www.w3.org/1999/xhtml">
    import _ from 'lodash'
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import MessageService from '@/request/message/message'
    import EventBus from '@/components/EventBus'
    import EberLayout from '@/components/EberLayout'
    import PermissionUtils from '@/utils/permission'
    import OrgService from '@/request/user/org'
    import OperationService from '@/request/aims/operation'
    import Cookies from 'js-cookie'
    export default {
        name: 'app',
        components: {
            EberLayout
        },
        computed: {
            ...mapGetters({
                user: 'user',
                adminOrgs: 'adminOrgs',
                isadmin: 'isadmin',
                routers: 'routers',
                permissions: 'permissions'
            })
        },
        data () {
            return {
                // hmenus: this.routers || [],
                tips: [],
                msgcount: 0,
                countMsgTimeout: null,
                operationCount: 0,
                countOperationTimeout: null,
                oids: []
            }
        },
        created: function () {
            this.listOids()
            this.countNotice()
            EventBus.$on('websocket-message', this.handleWebsocket)
        },
        beforeDestroy: function () {
            EventBus.$off('websocket-message', this.handleWebsocket)
        },
        watch: {
            adminOrgs () {
                this.createTips()
            },
            isadmin () {
                this.createTips()
            },
            oids () {
                this.countOperation()
            },
            permissions () {
                this.countOperation()
                this.createTips()
            },
            operationCount (val) {
                let index = _.findIndex(this.routers, {'name': 'operation'})
                if (index >= 0) {
                    this.$set(this.routers[index], 'badge', val)
                }
            }
        },
        methods: {
            listOids () {
                OrgService.listOrgId({
                    descendant: 1
                }).then(res => {
                    this.oids = res.result || []
                })
            },
            hasPermission (sns) {
                return PermissionUtils.hasPermission(sns, this.$store.getters.permissions, false)
            },
            createTips () {
                let arr = []
                if (!_.isEmpty(this.adminOrgs)) {
                    arr.push({
                        text: '控制台',
                        name: 'orgadmin',
                        url: '/orgadmin.html'
                    })
                }
                if (this.isadmin) {
                    arr.push({
                        text: '管理中心',
                        name: 'manager',
                        url: '/manager.html'
                    })
                    arr.push({
                        text: '开发文档',
                        name: 'helper',
                        url: 'https://www.kancloud.cn/biboheart/eber_service_api/608067',
                        target: '_blank'
                    })
                }
                if (this.hasPermission('per_count_0012')) {
                    const url = process.env['VUE_APP_COUNT_PATH'] || location.protocol + '//' + location.host
                    arr.push({
                        text: '大屏统计',
                        name: 'count',
                        url: url + '/bigindex.html?token=' + Cookies.get('user_token'),
                        target: '_blank'
                    })
                }
                if (this.hasPermission('per_refer_001')) {
                    const url = process.env['VUE_APP_REFER_PATH'] || location.protocol + '//' + location.host
                    arr.push({
                        text: '转诊管理',
                        name: 'refer',
                        url: url + '/transfer.html',
                        target: '_blank'
                    })
                }
                this.tips = _.clone(arr)
            },
            logout: function () {
                location.href = process.env['VUE_APP_LOGIN_URL'] + '?redirect=' + encodeURI(location.href)
            },
            goSelf: function () {
                location.href = '/self.html'
            },
            goNotice: function () {
                location.href = '/self.html#/notice'
            },
            clickLogo: function () {
                this.$router.push({name: 'record'})
            },
            countNotice () {
                MessageService.count({
                    readed: 0,
                    enabled: 1
                }).then(res => {
                    this.msgcount = res.result || 0
                }).catch(() => {
                    this.msgcount = 0
                }).finally(() => {
                    this.countMsgTimeout = null
                })
            },
            countOperation () {
                if (_.isEmpty(this.oids)) {
                    return
                }
                this.operationCount = 0
                let ps = []
                if (this.hasPermission('per_opration_001002')) {
                    ps.push(OperationService.count({
                        orgs: _.join(this.oids),
                        status: '2'
                    }).then(res => {
                        this.operationCount += res.result || 0
                    }))
                }
                if (this.hasPermission('per_opration_001003')) {
                    ps.push(OperationService.count({
                        start: moment().startOf('day').valueOf(),
                        end: moment().add(3, 'days').endOf('day').valueOf(),
                        orgs: _.join(this.oids),
                        status: '3'
                    }).then(res => {
                        this.operationCount += res.result || 0
                    }))
                }
                Promise.all(ps).finally(() => {
                    this.countMsgTimeout = null
                })
            },
            handleWebsocket (data) {
                if (!data) {
                    return
                }
                if (_.isString(data)) {
                    data = JSON.parse(data)
                }
                let message = data.message
                if (_.isEmpty(message)) {
                    return
                }
                if (data.source && data.source === 'eber-system-aims') {
                    if (this.countOperationTimeout === null) {
                        this.countOperationTimeout = setTimeout(() => {
                            this.countOperation()
                        }, 2000)
                    }
                }
                if (data.topic === 'user-message-save') {
                    if (message.readed) {
                        return
                    }
                    this.$notify({
                        message: message.msg || '收到一条消息',
                        type: 'info'
                    })
                    if (this.countMsgTimeout === null) {
                        this.countMsgTimeout = setTimeout(() => {
                            this.countNotice()
                        }, 2000)
                    }
                }
            }
        }
    }
</script>

<template>
    <eber-layout :hmenus="routers" :tips="tips" @logo-click="clickLogo" :badgeValue="msgcount">
        <div v-popover:userInfoPopover class="user-info clear" slot="user-info" @click="goSelf">
            <img :src="user ? user.pic : null | headimgFilter" class="headimg">
        </div>
        <el-popover
                ref="userInfoPopover"
                placement="bottom-start"
                trigger="hover"
                width="240"
                :visible-arrow="false"
                popper-class="user-info-popover">
            <div class="topbar-info-dropdown-memu">
                <div class="topbar-user-info">
                    <img :src="user ? user.pic : null | headimgFilter" class="topbar-user-avatar">
                    <p class="topbar-user-name">{{user ? user.name : ''}}</p>
                </div>
                <div class="topbar-user-entrance-list">
                    <a class="topbar-user-entrance clear" href="/self.html" target="_blank">
                        <i class="fas fa-clipboard-list info-prefix-icon"></i>
                        <span class="left-text">个人中心</span>
                    </a>
                    <a class="topbar-user-entrance clear" href="/self.html#/notice" target="_blank">
                        <i class="fas fa-comment-dots info-prefix-icon"></i>
                        <span class="left-text">消息中心</span>
                        <span class="right-text">{{msgcount || ''}}</span>
                    </a>
                    <a class="topbar-user-entrance clear" href="/self.html#/downloads" target="_blank">
                        <i class="fas fa-download info-prefix-icon"></i>
                        <span class="left-text">工具下载</span>
                    </a>
                </div>
                <div>
                    <div class="user-btn-list">
                        <span class="user-btn-link" @click="logout">退出登录</span>
                    </div>
                </div>
            </div>
        </el-popover>
        <router-view class="content-wrap"></router-view>
    </eber-layout>
</template>

<style scoped>
    .user-info {
        cursor: pointer;
        color: #bfcbd9;
    }
    .user-info .headimg {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        margin: 10px;
        float: left;
    }
    .topbar-info-dropdown-memu {
        padding: 0;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        font-size: 12px;
        min-width: 100%;
        margin: 0;
        border: none;
        -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.1);
        box-shadow: 0 1px 3px rgba(0,0,0,.2);
        white-space: nowrap;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    .topbar-info-dropdown-memu a,
    .topbar-info-dropdown-memu li,
    .topbar-info-dropdown-memu p,
    .topbar-info-dropdown-memu span {
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        letter-spacing: .02em;
        text-decoration: none;
        color: #333;
    }
    .topbar-info-dropdown-memu .topbar-user-info {
        text-align: center;
        padding-top: 16px;
        border-bottom: 1px solid #eaeaea;
    }
    .topbar-info-dropdown-memu .topbar-user-info .topbar-user-avatar {
        width: 36px;
        height: 36px;
        border-radius: 18px;
        vertical-align: middle;
    }
    .topbar-info-dropdown-memu .topbar-user-info .topbar-user-name {
        margin: 8px 0;
    }
    .topbar-info-dropdown-memu .topbar-user-entrance-list {
        overflow: hidden;
        width: 240px;
    }
    .topbar-info-dropdown-memu .topbar-user-entrance {
        display: block;
        cursor: pointer;
        height: 20px;
        line-height: 20px;
        padding: 0 16px;
        margin: 12px 0;
        font-size: 12px;
        line-height: 16px;
        position: relative;
    }
    .topbar-info-dropdown-memu .topbar-user-entrance .info-prefix-icon {
        width: 16px;
        height: 16px;
        vertical-align: text-bottom;
        margin-right: 8px;
        color: #333;
    }
    .topbar-info-dropdown-memu .topbar-user-entrance .right-text {
        float: right;
        font-size: 10px;
    }
    .topbar-info-dropdown-memu .user-btn-link {
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        display: block;
        -webkit-transition: all .15s;
        transition: all .15s;
        text-align: center;
        color: #333;
        background-color: #f5f5f6;
        border-top: #eaeaea;
    }
</style>
